import { defineMessages } from 'react-intl';

export default defineMessages({
  prepositionOr: {
    id: 'app.common.prepositions.or',
    defaultMessage: 'or',
  },
  navigationBackLink: {
    id: 'app.common.navigation.link.back',
    defaultMessage: 'Back',
  },
  searchBarPlaceholder: {
    id: 'app.common.search.placeholder',
    defaultMessage: 'Search',
  },
  unauthorizedTitle: {
    id: 'app.unauthorized.title',
    defaultMessage: 'Nothing to see here!',
  },
  unauthorizedText: {
    id: 'app.unauthorized.text',
    defaultMessage:
      'Unfortunately you don’t have permission to view this page. If you think this is a mistake, please contact your {accountType}:',
  },
  unauthorizedButtonText: {
    id: 'app.unauthorized.button.text',
    defaultMessage: 'View my products',
  },
});
